export default __webpack_public_path__ + "img/mostly-cloudy-storm.c362773.svg";